Controller.$inject = [];

function Controller() {
    const self = this;

    self.$postLink = () => {
       self.color = self.parentCtrl.color;
    };
}

export function HuiAlertAction() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        require: {
            parentCtrl: '^huiAlert'
        },
        bindToController: {
            disabled: '<?'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
               <div>
                   <hui-button
                       class="hui-alert-action"
                       variant="ghost"
                       ng-disabled="$huiCtrl.disabled"
                       color="{{$huiCtrl.color}}"
                       sizing="md">
                       <ng-transclude></ng-transclude>
                   </hui-button>
               </div> 
            `;
        }
    };
}



